import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/d2e9835f-811e-4e7a-bbc6-443e0c4db638.jpg'
import { useIntl } from 'react-intl';

const TravbusinessSolutionsForOperationsManagersPage: React.FC = () => {
  const intl = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'streamlined-bookings', title: intl.formatMessage({ id: 'operation-mgrs.streamlined.bookings' }) },
    { id: 'policy-&-workflow-integration', title: intl.formatMessage({ id: 'operation-mgrs.policy.workflow.integration' }) },
    { id: 'real-time-insights-dashboards', title: intl.formatMessage({ id: 'operation-mgrs.real.time.insights.dashboards' }) },
    { id: '24/7-support-for-emergencies', title: intl.formatMessage({ id: 'operation-mgrs.24.7.support.for.emergencies' }) },
    { id: 'cost-control-efficiency', title: intl.formatMessage({ id: 'operation-mgrs.cost.control.efficiency' }) },
  ];

const sections: IContentSection[] = [
  {
    id: 'operation-mgrs.streamlined-bookings',
    title: intl.formatMessage({ id: 'operation-mgrs.streamlined.bookings' }),
    paragraphs: [
      intl.formatMessage({ id: 'operation-mgrs.streamlined.bookings.p1' }),
      intl.formatMessage({ id: 'operation-mgrs.streamlined.bookings.p2' }),
    ],
  },
  {
    id: 'operation-mgrs.policy-and-workflow-integration',
    title: intl.formatMessage({ id: 'operation-mgrs.policy.workflow.integration' }),
    paragraphs: [
      intl.formatMessage({ id: 'operation-mgrs.policy.workflow.integration.p1' }),
      intl.formatMessage({ id: 'operation-mgrs.policy.workflow.integration.p2' }),
    ],
  },
  {
    id: 'operation-mgrs.real-time-insights-dashboards',
    title: intl.formatMessage({ id: 'operation-mgrs.real.time.insights.dashboards' }),
    paragraphs: [
      intl.formatMessage({ id: 'operation-mgrs.real.time.insights.dashboards.p1' }),
      intl.formatMessage({ id: 'operation-mgrs.real.time.insights.dashboards.p2' }),
    ],
  },
  {
    id: 'operation-mgrs.24-7-support-for-emergencies',
    title: intl.formatMessage({ id: 'operation-mgrs.24.7.support.for.emergencies' }),
    paragraphs: [
      intl.formatMessage({ id: 'operation-mgrs.24.7.support.for.emergencies.p1' }),
    ],
  },
  {
    id: 'operation-mgrs.cost-control-efficiency',
    title: intl.formatMessage({ id: 'operation-mgrs.cost.control.efficiency' }),
    paragraphs: [
      intl.formatMessage({ id: 'operation-mgrs.cost.control.efficiency.p1' }),
      intl.formatMessage({ id: 'operation-mgrs.cost.control.efficiency.p2' }),
      intl.formatMessage({ id: 'operation-mgrs.cost.control.efficiency.p3' }),
    ],
  },
];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'operation-mgrs.headers.title' })}
        headerSubtitle={intl.formatMessage({ id: 'operation-mgrs.headers.subtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='top'
      />
    </div>
  );
};

export default TravbusinessSolutionsForOperationsManagersPage;
